import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getBlockId from '../../../utils/getBlockId';
import { VOID_BLOCKS } from '../../../types/BlockTypes';
export default function getNodeData(node) {
  var defaultAttrs = {
    id: getBlockId(node)
  };
  var dataAttrs = node.data.isEmpty() ? {} : node.data.toJS(); // Support attribute for old editor

  var atomicAttrs = VOID_BLOCKS.includes(node.type) ? {
    atomic: true
  } : {};
  return _objectSpread({}, atomicAttrs, {}, dataAttrs, {}, defaultAttrs);
}